<template>
  <LayoutSearchFieldVertical
    v-if="facet"
    display-variant="list"
  >
    <div class="facet-buttons">
      <button
        class="fb-button"
        v-for="(count, db) in counts"
        :class="{
          'is-0': count === 0,
          'is-exclude': exclude,
          'is-selected': isSelected('+' + db),
        }"
        @click="select(db)"
        :key="db"
      >
        <UiDbSpan class="fb-label" :id="db" tag="span">
          <template v-slot="{ db }">
            {{ dbDisplay(db) }}
          </template>
        </UiDbSpan>
        <span class="fb-count" :title="num(count)">{{ nums(count) }}</span>
      </button>
    </div>

    <template #nav>
      <a @click="showAll()">{{
        lss('すべてを表示/複数を選択する', 'Show all/Multi select')
      }}</a>
      <SearchFieldDatabaseExpandModal
        ref="expand"
        :facet="facet"
        :ss="props.ss"
        :def="props.field"
      />
    </template>
    <template #options>
      <BaseToggleSwitch class="is-red" v-model="exclude">{{
        lss('除外条件を指定', 'Exclude')
      }}</BaseToggleSwitch>
    </template>
  </LayoutSearchFieldVertical>
</template>

<script lang="ts" setup>
import { useSearchFieldBase } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldBaseProps } from '~/components/search/search-field/useBaseSearchField'
import type { SearchFieldDatabaseExpandModal } from '#components'

const DATABASE_FACET_LEN = 10
const { ls, lss, num, nums } = useI18n()

interface Props extends SearchFieldBaseProps {
}
const props = withDefaults(defineProps<Props>(), {
})

const { facet, excludeDisplay } = useSearchFieldBase(props)

const exclude: Ref<boolean> = ref(false)

const count = db => {
  if (!facet.value) return undefined
  return facet.value.counts[db] || 0
}

const select = (db: string) => {
  if (exclude.value) db = '-' + db
  else db = '+' + db
  if (isSelected(db)) {
    props.ss.removeFilter(props.field.key, [db])
  } else {
    props.ss.addFilter(props.field.key, [db])
  }
}

const isSelected = (db: string) => {
  return props.ss.state.filter[props.field.key]?.includes(db)
}

const dbDisplay = (db: Database) => {
  if (db) {
    let v = ls(db.name)
    return excludeDisplay(v, exclude.value, count(db.id))
  }
  return ''
}

const expand = ref<InstanceType<typeof SearchFieldDatabaseExpandModal>>()
const showAll = async () => {
  try {
    let selected = await expand.value.openAwait()
    if (exclude.value) selected = selected.map(s => s.replace('+', '-'))
    props.ss.setFilter(props.field.key, selected)
  } catch (cancel) {}
}

const counts = computed(() => {
  if (!facet.value) return {}
  const keys = Object.keys(facet.value.counts)
    .sort((a, b) => facet.value.counts[b] - facet.value.counts[a])
    .slice(0, DATABASE_FACET_LEN)
  let obj = {}
  keys.forEach(key => {
    obj[key] = facet.value.counts[key]
  })
  return obj
})
</script>
